import type { CartType } from '../types/cart'

export const cartInitialValues: CartType = {
  subscribePromo: [],
  otpPromo: [],
  otp: [],
  subscribe: [],
  addedLines: { items: [] },
  promoItems: [],
}
